Namespace 'Customer.Filters'

class Customer.Filters.MainConfigCardView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/general/main_config_card']
  className: 'filter-field-container filter-config-container'

  initialize: ({@filter, @query, canManageGlobal, editable}) ->
    @colorPickerView = new Customer.Filters.ColorPickerView({color: @filter.get('color')})
    @visibilityView = new Customer.Filters.VisibilityView
      title: I18n.t('customer.dashboard.filters.creation.privacy')
      visibility: {user_id: @filter.get('user_id'), global: @filter.isGlobal()}
      canManageGlobal: canManageGlobal
      editable: editable

    @listenTo(@visibilityView, 'toggleVisibility', (isGlobal) => @trigger('filter:toggleVisibility', isGlobal))

  render: ->
    @$el.html @template({filterName: @query.get('name')})
    @$('.colors-container').empty().append(@colorPickerView.render().el)
    @$('.is-global-container').empty().append(@visibilityView.render().el)
    @

  getColor: =>
    @colorPickerView.getColor()

  getFilterTitle: =>
    @_filterTitleEl().val().trim()

  getVisibility: =>
    @visibilityView.getVisibility()

  showErrors: (errors) =>
    if errors.includes('title')
      invalidClass = 'is-invalid'
      @_filterTitleEl().addClass(invalidClass)
      @_filterTitleEl().one('input', => @_filterTitleEl().removeClass(invalidClass))

  cleanErrors: =>
    @_filterTitleEl().removeClass('is-invalid')

  _keepCustomerSessionAlive: ->
    Backbone.trigger 'customerSession:keepAlive'

  _filterTitleEl: ->
    @$el.find('#filter_title_input')

  closeColorPicker: ->
    @colorPickerView.destroyColorPicker()
